import React from 'react'

import { Container, ContentHeader, LoadingBox, Page } from 'components'

import { SSOCorporateGroupForm } from './components'

import { useFetch } from 'hooks'

import * as service from 'service'

const SSOCorporateGroupShow = ({ match }) => {
  const {
    params: { ssoCorporateGroupId },
  } = match

  const { response, isLoading } = useFetch(
    service.dponet.ssoCorporateGroups.get,
    { ssoCorporateGroupId },
    [],
  )

  const ssoCorporateGroup = response?.data?.ssoCorporateGroup
  const companies = response?.data?.ssoCorporateGroup?.companies
  const users = response?.data?.ssoCorporateGroup?.users
  return (
    <Page title="Visualizar Organização SSO-SAML">
      <Container
        maxWidth={false}
        spacingXl={30}
        spacingLg={25}
        spacingMd={10}
        spacingSm={10}
      >
        <ContentHeader
          menu="Organização SSO-SAML"
          title="Visualizar"
          subtitle="Visualização da Organização SSO-SAML"
        />
        {isLoading ? (
          <LoadingBox />
        ) : (
          <SSOCorporateGroupForm
            show
            ssoCorporateGroup={ssoCorporateGroup}
            ssoCorporateGroupCompanies={companies}
            ssoCorporateGroupUsers={users}
          />
        )}
      </Container>
    </Page>
  )
}

export default SSOCorporateGroupShow
